<template>
  <v-layout row justify-center>
    <v-dialog v-model="visible" max-width="325px" v-click-outside="close">
      <v-card>
        <v-card-title class="title font-weight-regular justify-space-between">
          <span>{{ this.$t('chat_chat_message_forward') }}</span>
        </v-card-title>

        <v-layout justify-center>
          <v-btn-toggle v-model="isGroup" mandatory class="forward-toggle">
            <v-btn flat :value="false">
              <v-icon>person</v-icon>
              <span>{{this.$t('chat_menu_contacts_book') }}</span>
            </v-btn>
            <v-btn flat :value="true">
              <v-icon>group</v-icon>
              <span>{{this.$t('chat_btn') }}</span>
            </v-btn>
          </v-btn-toggle>
        </v-layout>

        <search :searchFilter.sync="searchFilter"  />

        <v-list class="forward--scroll-list">
          <v-list-tile
            v-for="item in filteredItems"
            :key="item.title ? item.title : item.chatId"
            @click="onContactClicked(item)"
            :class="selected(item)"
            style="height: 45px !important;"
          >
            <v-list-tile-avatar>
              <user-avatar 
                :avatar="item.avatar"
                :username="item.title" 
                :size="38"
              />
            </v-list-tile-avatar>

            <v-list-tile-content>
              <v-list-tile-title v-html="getTitle(item)" ></v-list-tile-title>
            </v-list-tile-content>

          </v-list-tile>
        </v-list>

        <v-divider></v-divider>

        <v-card-actions>
          <v-btn
            flat
            @click="close"
          >
             {{ this.$t('cancel') }}
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
            :loading="loading"
            :disabled="nextDisabled"
            color="primary"
            depressed
            @click="next"
          >
            {{ this.$t('next_btn') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<style>
  .forward--scroll-list {
    height: 458px;
    overflow-x: hidden;
    overflow-y: auto;
  }
  .forward-toggle {
    box-shadow: unset !important;
    margin-bottom:10px;
    border:1px solid rgba(0,0,0,.12);
  }
  .v-btn-toggle .v-btn .v-icon {
    font-size: medium;
    margin-right:8px;
  }
</style>

<script> 
  import UserAvatar from '@common/UserAvatar.vue'
  import Search from '@common/Search.vue'

  export default {
    name: 'forward-message',
    data: () => ({
      items: [],
      selectedItems: [],
      searchFilter:'',
      filteredItems: [],
      isGroup: false,
    }),
    components: { UserAvatar, Search },
    computed: {
      nextDisabled() { 
        return !this.selectedItems.length 
      }
    },
    props: {
      visible: {
        type: Boolean, 
        default: false
      },
      message: {
        type: Object,
        required: true
      },
    },
    methods: {
      close() {
        if (!this.visible)
          return
        // reset all variables
        this.selectedItems = []
        this.searchFilter = ''
        this.$emit('update:visible', false)
      },
      next() {
        const state = this.$store.state
        // TODO: forward to chat not contacts
        this.selectedItems.forEach(item => {
          // is chatId with contact exists
          const chat = state.chats.find(c => c.chatId == item.chatId)
          if (chat == undefined) {
            this.$store.dispatch('openSingleChat', { chatId:item.chatId, contactId:item.contactId }).then(cid => {
              this.$store.dispatch('forwardChatMessage', { recipientChat:cid, message:this.message })
            })
          } else {
            this.$store.dispatch('forwardChatMessage', { recipientChat:chat.chatId, message:this.message })
          }
        })
        this.close()
      },
      selected(item) {
        return (this.selectedItems.includes(item)) ? 'accent' : ''
      },
      onContactClicked(item){
        if (this.selectedItems.includes(item)) {
          this.selectedItems.splice(this.selectedItems.indexOf(item), 1 )
        } else {
          this.selectedItems.push(item)
        }
      },
      updateItems() {
        let s = this.$store.state
        let items = this.isGroup 
          ? s.chats.filter(it => !(!it.group && it.lastMessage === ''))
          : s.contacts
        //console.log('-- items: ' + JSON.stringify(items))
        if (!this.isGroup)
          items.map(item => item.title = item.name)

        this.items = items
        this.updateFilteredItems()
      },
      updateFilteredItems() {
        if (this.searchFilter !== '') {
          const filter = new RegExp(this.searchFilter, 'i')
          this.filteredItems = this.items.filter(it => it.title.match(filter))
        } else {
          this.filteredItems = this.items
        }
      },
      getTitle(item) {
        return this.safeTextWithEmoji(item.title)
      }
    },
    watch: {
      visible: function(newValue, oldValue) {
        if (newValue)
          this.updateItems()
      },
      isGroup: function(newValue, oldValue) {
        this.updateItems()
      },
      searchFilter: function(newValue, oldValue) {
        this.updateFilteredItems()
      }
    }
  }
</script>